import React from 'react';
import { Box, Typography, Container, Paper, Divider } from '@mui/material';

function PrivacyPolicy() {
  return (
    <Box sx={{ py: 15, bgcolor: '#f9f9f9' }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 6, borderRadius: 4 }}>
          <Typography variant="h3" fontWeight={800} gutterBottom sx={{ color: '#034522' }}>Privacy Policy</Typography>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>Last Updated: December 25, 2025</Typography>
          <Divider sx={{ my: 3 }} />

          <Typography paragraph>
            At GrowAITech, we value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
          </Typography>

          <Typography variant="h5" fontWeight={700} sx={{ mt: 4, mb: 2, color: '#1A9E7F' }}>1. Information We Collect</Typography>
          <Typography paragraph>
            We may collect personal information such as your name, email address, phone number, and company details when you fill out contact forms, subscribe to our newsletter, or apply for services. We also collect non-personal data like browser type and IP address for analytics purposes.
          </Typography>

          <Typography variant="h5" fontWeight={700} sx={{ mt: 4, mb: 2, color: '#1A9E7F' }}>2. How We Use Your Information</Typography>
          <Typography paragraph>
            Your data is used to:
            <ul>
                <li>Provide and maintain our services.</li>
                <li>Communicate with you regarding updates, offers, and support.</li>
                <li>Improve our website and user experience.</li>
                <li>Comply with legal obligations.</li>
            </ul>
          </Typography>

          <Typography variant="h5" fontWeight={700} sx={{ mt: 4, mb: 2, color: '#1A9E7F' }}>3. Data Protection</Typography>
          <Typography paragraph>
            We implement industry-standard security measures to protect your data from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.
          </Typography>

          <Typography variant="h5" fontWeight={700} sx={{ mt: 4, mb: 2, color: '#1A9E7F' }}>4. Third-Party Sharing</Typography>
          <Typography paragraph>
            We do not sell or rent your personal information to third parties. We may share data with trusted service providers who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential.
          </Typography>

          <Typography variant="h5" fontWeight={700} sx={{ mt: 4, mb: 2, color: '#1A9E7F' }}>5. Contact Us</Typography>
          <Typography paragraph>
            If you have any questions about this Privacy Policy, please contact us at <strong>growaitech@gmail.com</strong>.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default PrivacyPolicy;
